import { PATTERNS } from '../../constants/validations';

const SSN_MASK = '***-**-';
const SSN_MASK_LENGTH = 7;

export default (value, { expectedLengthShort, expectedLengthFull }) => {
  if (!value || value.substr(0, SSN_MASK_LENGTH) === SSN_MASK) return true;

  const valueLength = String(value).length;
  const isValidSSN =
    !value || valueLength === 0 ? true : PATTERNS.SSN.test(value);
  if (expectedLengthShort && expectedLengthFull) {
    return valueLength === 0
      ? true
      : isValidSSN &&
          (valueLength === expectedLengthShort ||
            valueLength === expectedLengthFull);
  }
  return valueLength === 0
    ? true
    : isValidSSN && valueLength === expectedLengthShort;
};



// WEBPACK FOOTER //
// ./src/utils/validations/SSNValidator.js